module.exports = __webpack_public_path__ + "img/b_left.80bb684a.png";